/**
 * IMPORTS
 */
import { MessageSquareText, UserPlus } from "lucide-react";

import type { INotificacao } from "@/interface/conversa-cliente";
import { formatarDataHora, formatarTempoRelativo } from "@/utils/formatar-tempo-relativo";

import { AcoesConvite } from "./acoes-convite";

type NotificacaoLinhaProps = {
  notificacao: INotificacao;
  onAbrir: (notificacao: INotificacao) => void;
  compacta?: boolean;
};

/**
 * Notificação clicável. Convites para a conversa trazem os botões aceitar/recusar fora do
 * botão principal (botão dentro de botão é HTML inválido).
 */
function NotificacaoLinha({ notificacao, onAbrir, compacta }: NotificacaoLinhaProps) {
  const convite = notificacao.convite;
  const Icone = convite ? UserPlus : MessageSquareText;

  return (
    <div className={notificacao.lida ? "" : "bg-orange-50"}>
      <button
        type="button"
        onClick={() => onAbrir(notificacao)}
        className="flex w-full gap-3 px-3 py-2.5 text-left transition-colors hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-custom900"
      >
        <span className="mt-0.5 flex size-8 shrink-0 items-center justify-center rounded-full bg-gray-100 text-gray-600">
          <Icone className="size-4" />
        </span>
        <span className="min-w-0 flex-1">
          <span className="flex items-start gap-2">
            <span
              className={`flex-1 text-sm text-gray-900 ${notificacao.lida ? "" : "font-semibold"}`}
            >
              {notificacao.titulo}
            </span>
            {!notificacao.lida && (
              <span className="mt-1.5 size-2 shrink-0 rounded-full bg-orange-500">
                <span className="sr-only">Não lida</span>
              </span>
            )}
          </span>
          <span
            className={`block text-xs text-gray-600 ${
              compacta ? "line-clamp-2" : "whitespace-pre-wrap break-words"
            }`}
          >
            {notificacao.mensagem}
          </span>
          <time
            dateTime={notificacao.created_at}
            title={formatarDataHora(notificacao.created_at)}
            className="mt-1 block text-[11px] text-gray-500"
          >
            {formatarTempoRelativo(notificacao.created_at)}
          </time>
        </span>
      </button>
      {convite && (
        <div className="px-3 pb-2.5 pl-14">
          <AcoesConvite
            conviteId={convite.id}
            status={convite.status}
            onAceito={() => onAbrir(notificacao)}
          />
        </div>
      )}
    </div>
  );
}

/**
 * EXPORTS
 */
export { NotificacaoLinha };
